import { render, staticRenderFns } from "./OverrideBusinessHours.vue?vue&type=template&id=94a24aca&scoped=true"
import script from "./OverrideBusinessHours.vue?vue&type=script&lang=js"
export * from "./OverrideBusinessHours.vue?vue&type=script&lang=js"
import style0 from "./OverrideBusinessHours.vue?vue&type=style&index=0&id=94a24aca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a24aca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94a24aca')) {
      api.createRecord('94a24aca', component.options)
    } else {
      api.reload('94a24aca', component.options)
    }
    module.hot.accept("./OverrideBusinessHours.vue?vue&type=template&id=94a24aca&scoped=true", function () {
      api.rerender('94a24aca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/company/onboarding/OverrideBusinessHours.vue"
export default component.exports